import React, { memo } from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmCancelDialog = ({ show, title, callback, children }) => {
    return (
        <Modal show={show} onHide={() => callback("cancel")} centered={true}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => callback("cancel")}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => callback("confirm")}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default memo(ConfirmCancelDialog);
